import { render, staticRenderFns } from "./SaleReturnReportTab.vue?vue&type=template&id=23754d46&scoped=true&"
import script from "./SaleReturnReportTab.vue?vue&type=script&lang=js&"
export * from "./SaleReturnReportTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23754d46",
  null
  
)

export default component.exports